import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from 'features/core/shared/mvs-page/page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';
import {PageHeaderConfig} from 'features/core/shared/service/page/page-header-config.interface';
import {
    MvsConfigHeaderComponent
} from 'features/core/shared/components/mvs-config-header/mvs-config-header.component';

/**
* Provisions-Import page (P3) for Sachbearbeitung.
*
* Entry point for starting a commission-statement import: the user picks a Gesellschaft
* (cn.CommissionPartner), chooses an import method (Lokaler AI Agent / Strukturierte Datei /
* Manuell) and — for 'Lokaler AI Agent' — receives a generated, copyable prompt.
*
* Header runs in Component-Mode via MvsConfigHeaderComponent ('Provisions-Import'), with
* cross-links to the Provisions-Dashboard, the Abgleich screen and the cn config page so all
* cn screens stay reachable.
*
* NOTE (architecture shell): the partner selection, the import-method chooser and the generated
* prompt panel live in the hosted CnImportStartComponent (mvs-cn-import-start) and its data layer,
* which the Data / Component specialist wires next. This file establishes the routed page
* skeleton, the inheritance contract and the header only; the body currently hosts a placeholder
* until that component is declared in CnModule.
*/
@Component({
    selector: 'mvs-cn-import-page',
    templateUrl: './cn-import.page.html',
    styleUrls: ['./cn-import.page.scss'],
    standalone: false
})
export class CnImportPage extends PageComponent implements OnInit {

    defaultLabel: string = 'Provisions-Import';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        this.defaultLabel = 'Provisions-Import';
        super.ngOnInit();
        this.initialized = true;
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Provisions-Import',
                categoryTypeMode: 'configuration',
                icon: 'fa-light fa-file-import',
                links: [
                    {label: 'Eingangsfreigabe', icon: 'fa-light fa-clipboard-check', url: 'cn/import-review'},
                    {label: 'Dashboard', icon: 'fa-light fa-gauge', url: 'cn/dashboard'},
                    {label: 'Abgleich', icon: 'fa-light fa-scale-balanced', url: 'cn/reconciliation'},
                    {label: 'Konfiguration', icon: 'fa-light fa-coins', url: 'cn/config'}
                ]
            }
        };
    }
}
